import React from "react";
import ServiceCardSection3 from "./ServiceCardSection3";

const ServiceSection3 = () => {
  return (
    <div id="why">
    <div className="choosing-institution bg-slate-100 mt-40">
      <div className="institution text-center">
        <h1 className="head   pt-24 text-4xl font-semibold text-blue-900 lg:text-5xl lg:pt-32">
          Why <a className="underline decoration-orange-700">Choose Our </a>
          School
        </h1>
        {/* <p className="tail px-5 text-xl font-normal">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Omnis sed et
          necessitatibus ipsam sunt temporibus aspernatur voluptatem ad, <br />
          recusandae perspiciatis, consectetur dolorem possimus quaerat ab
          architecto deleniti, est vel aut.
        </p> */}
      </div>
      <div
        className="icon lg:mt-14 flex flex-col items-center lg:mx-24 lg:flex-row 
      "
      >
        <ServiceCardSection3
          image="https://cdn-icons-png.flaticon.com/512/7497/7497739.png"
          heading="Culture, Values and Ethics"
          para="Ethics are a system of moral principles "
        />
        <ServiceCardSection3
          image="https://cdn-icons-png.flaticon.com/512/4576/4576967.png"
          heading="Encouraging"
          para="To help someone to feel confident and able to do something"
        />
        <ServiceCardSection3
          image="https://cdn-icons-png.flaticon.com/512/5841/5841994.png"
          heading="Education Focused"
          para=" it is the gateway to all thinking"
        />
        <ServiceCardSection3
          image="https://cdn-icons-png.flaticon.com/512/6005/6005439.png"
          heading="Authentic"
          para="
          Authenticity is being true to who you are and expressing yourself"
        />
      </div>
    </div>
    </div>
  );
};

export default ServiceSection3;
